module.exports = ['$scope', ($scope) ->
  @formatDifference = (amount) ->
    amount = if amount < 0 then amount * -1 else amount

  @
]
